// extracted by mini-css-extract-plugin
export default {"container":"scaleTransition_container__5f7iD"};